export default __webpack_public_path__ + "static/char-v-30-zh-Hant-4e0a8965cdf7e544bdfd12c9f0249e8e.mp4";